module.exports = __webpack_public_path__ + "background-image.1224c1edef6102d17c6c.png";


//////////////////
// WEBPACK FOOTER
// /Users/amanmathur/Desktop/Projects/McHacks_2018/Web/src/assets/background-image.png
// module id = ../../../../../src/assets/background-image.png
// module chunks = main